import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';
import tableLiveSportRoomConfigContent from './tableLiveSportRoomConfigContent';

export default {
  title: 'Room Config Contents',
  attributeName: 'sportRoomsConfigContents',
  contentFormUrl:'liveSportRoomContent',
  fields: [
    {
      attributeName: 'sportRoomsConfigContentTable',
      type: FormInputTypes.TABLECOMPONENT,
      mode:'POPUP',
      helpText: '',
      configFile: tableLiveSportRoomConfigContent,

    },
  ],
};
